import { domain } from '../utils/constant'
import { http } from '../utils/http'

export async function fetchUsers(pageSize: number, page: number, search: string, shopId: number) {
  return http.get(
    `/user/list?page=${page}&page_size=${pageSize}&search=${search}${shopId === 0 ? '' : `&shop_id=${shopId}`}`
  )
}

// 黑名单用户列表
export async function fetchBlackList(page_size: number, page: number, search?: string, shop_id?: number) {
  const params: any = {
    page,
    page_size,
  }
  if (search) params.search = search
  if (shop_id) params.shop_id = shop_id
  return http.get(`/user/blackList`, { params })
}

// 拉黑用户(状态，0：正常，1：拉黑)
export async function blacklistUser(data: { phone?: string; status?: number; remark?: string }) {
  return http.post(`/user/update`, data)
}


// 评价列表
export async function fetchComment(page_size: number, page: number, search?: string) {
  const params: any = {
    page,
    page_size,
  }
  if (search) params.search = search
  return http.get(`/comment/list`, { params })
}

// 确认评价发券
export async function confirmComment(data: { comment_id?: number; }) {
  return http.post(`/comment/confirm`, data)
}

// 取消评价发券
export async function cancelComment(data: { comment_id?: number; remark: string }) {
  return http.post(`/comment/cancel`, data)
}

// 评价消息
export async function fetchCommentMessage() {
  return http.get(`/comment/message`)
}


export async function fetchOrders(page_size: number, page: number, search?: string, shop_id?: string, star?: string, start_time?: string, end_time?: string, transfer_type?: string, pay_channel?: string) {
  const params: any = {
    page,
    page_size,
  }
  if (search) params.search = search
  if (shop_id) params.shop_id = shop_id
  if (star) params.star = star
  if (start_time) params.start_time = start_time
  if (end_time) params.end_time = end_time
  if (transfer_type) params.transfer_type = transfer_type
  if (pay_channel) params.pay_channel = pay_channel
  return http.get(`/order/list`, { params })
}

export async function fetchOrderDetail(order_no: string) {
  let query = `?order_no=${order_no}`
  return http.get(`/order/detail${query}`)
}

// 订单评价列表
export async function fetchOrderReviewList(page_size: number, page: number, shop_id?: string, star?: string) {
  const params: any = {
    page,
    page_size,
  }
  if (shop_id) params.shop_id = shop_id
  if (star) params.star = star
  return http.get(`/order/reviewList`, { params })
}

// 订单售后列表
export async function fetchOrderAfterSaleList(page_size: number, page: number, search?: string, shop_id?: string) {
  const params: any = {
    page,
    page_size,
  }
  if (shop_id) params.shop_id = shop_id
  if (search) params.search = search
  return http.get(`/order/afterSaleList`, { params })
}

// 订单售后列表
export async function updateOrderAfterSale(id: number, status: number, amount?: string) {
  return http.post(`/order/afterSale`, { id, status, amount })
}

// 订单售后消息
export async function fetchAfterSaleMessage() {
  return http.get(`/order/afterSaleMessage`)
}

// 订单评价消息
export async function fetchReviewMessage() {
  return http.get(`/order/reviewMessage`)
}

// 核销退款
export async function orderRefund(order_no: string) {
  return http.post(`/order/refund`, {
    order_no
  })
}

export async function fetchRechargeRecord(
  page_size: number,
  page: number,
  search?: string,
  shop_id?: string,
  start_time?: string,
  end_time?: string,
  min_amount?: number,
  max_amount?: number
) {
  const params: any = {
    page,
    page_size
  }
  if (search) params.search = search
  if (shop_id) params.shop_id = shop_id
  if (start_time) params.start_time = start_time
  if (end_time) params.end_time = end_time
  if (min_amount != null) params.min_amount = min_amount
  if (max_amount != null) params.max_amount = max_amount
  return http.get(`/recharge/record`, { params })
}

export async function fetchBonusList(page_size: number, page: number, user_id?: string, shop_id?: string,
  start_time?: string, end_time?: string) {
  const params: any = {
    page,
    page_size
  }
  if (user_id) params.user_id = user_id
  if (shop_id) params.shop_id = shop_id
  if (start_time) params.start_time = start_time
  if (end_time) params.end_time = end_time

  return http.get(`/recharge/bonusList`, { params })
}

export async function fetchUser(id: string, shop_id?: string) {
  let query = `?user_id=${id}`
  if (shop_id) {
    query = `${query}&shop_id=${shop_id}`
  }
  return http.get(`/user/detail${query}`)
}

export async function fetchTotalData() {
  return http.get(`/analysis/income`)
}

export async function fetchDataList(shop_id?: string, start_time?: string, end_time?: string) {
  let query = []
  if (shop_id) {
    query.push(`shop_id=${shop_id}`)
  }
  if (start_time) {
    query.push(`start_time=${start_time}`)
  }
  if (end_time) {
    query.push(`end_time=${end_time}`)
  }
  return http.get(`/analysis/count${query.length ? `?${query.join('&')}` : ''}`)
}

export async function fetchUserOrders(
  id: string,
  type: string,
  other: {
    page_size: number
    page: number
    order_no: string
    start_time: string // 2024-01-01 00:00:00
    end_time: string
    shop_id?: string | number
  }
) {
  let query = `user_id=${id}&type=${type}&start_time=${other.start_time}&end_time=${other.end_time}&page=${other.page}&page_size=${other.page_size}`
  if (other.order_no) {
    query += `&order_no=${other.order_no}`
  }
  if (other.shop_id) {
    query += `&shop_id=${other.shop_id}`
  }
  return http.get(`/amount/list?${query}`)
}

export async function setUserBalance(user_id: string, amount: number, shop_id: any) {
  return http.post('/amount/balance', {
    user_id,
    amount,
    shop_id
  })
}

export async function reduceBalance(user_id: string, amount: number, shop_id: any) {
  return http.post('/amount/reduce', {
    user_id,
    amount,
    shop_id
  })
}

export async function fetchMeituanSession(auth_code: string) {
  return http.post('/receipt/session', {
    auth_code,
    redirect_url: `https://${domain}/callback`
  })
}

export async function fetchReceiptAuthUrl() {
  return http.get('/receipt/authUrl')
}

export async function fetchRefundList(page_size: number, page: number, search?: string, shop_id?: string) {
  const params: any = {
    page,
    page_size,
  }
  if (shop_id) params.shop_id = shop_id
  if (search) params.search = search
  return http.get(`/refund/list`, { params })
}

export async function fetchRefundMessage() {
  return http.get(`/refund/message`)
}

export async function cancelRefund(form: AnyObject) {
  return http.post(`/refund/cancel`, form)
}

export async function okRefund(form: AnyObject) {
  return http.post(`/refund/confirm`, form)
}

// 门店管理
export async function fetchShopList(page: number, pageSize: number, includeClosed?: boolean, region?: string) {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  })
  if (includeClosed) params.set('include_closed', '1')
  if (region) params.set('region', region)
  return http.get(`/shop/list?${params.toString()}`)
}

// 发券门店列表
export async function fetchTicketShopList(page: number, pageSize: number) {
  return http.get(`/shop/ticketList?page=${page}&page_size=${pageSize}`)
}


export async function deleteShop(form: { shop_id?: number }) {
  return http.post(`/shop/delete`, form)
}

export async function createShop(form: any) {
  return http.post(`/shop/add`, form)
}

export async function updateShop(form: any) {
  return http.post(`/shop/update`, form)
}

// 充值管理
export async function fetchShopRecharge() {
  return http.get(`/recharge/list`)
}

export async function updateShopRecharge(form: {
  recharge_id: number
  shop_id: number
  amount: number
  status: number
  bonus_amount: number
  is_recommend: number
}) {
  return http.post(`/recharge/update`, form)
}

export async function createShopRecharge(form: {
  shop_id: number
  amount: number
  status: number
  bonus_amount: number
  is_recommend: number
}) {
  return http.post(`/recharge/add`, form)
}

// 删除充值套餐
export async function deleteShopRecharge(form: any) {
  return http.post(`/recharge/delete`, form)
}

export async function fetchShopPackage() {
  return http.get(`/commodity/list`)
}

export async function updateShopPackage(form: any) {
  return http.post(`/commodity/update`, form)
}

export async function createShopPackage(form: any) {
  return http.post(`/commodity/add`, form)
}

// 删除洗车套餐
export async function deleteShopPackage(form: any) {
  return http.post(`/commodity/delete`, form)
}

export async function stopDevice(form: { sn: string }) {
  return http.post('/device/shutdown', form)
}

export async function addDevice(form: any) {
  return http.post('/device/add', form)
}

export async function updateDevice(form: any) {
  return http.post('/device/update', form)
}

export async function fetchIccExpire(params: { icc_id: string }) {
  return http.get('/device/iccExpire', { params })
}

export async function updateDeviceIntelligent(form: any) {
  return http.post('/device/setIntelligent', form)
}

export async function updateDeviceRate(form: any) {
  return http.post('/device/setRate', form)
}

export async function updateDeviceGatewayIp(form: { sn: string }) {
  return http.post('/device/updateGatewayIp', form)
}

export async function fetchDeviceGatewayIpPreview(params: { sn: string }) {
  return http.get('/device/gatewayIpPreview', { params })
}

export async function restartDevice(form: { sn: string }) {
  return http.post('/device/restart', form)
}

export async function fetchDeviceFirmwareList(params: { sn: string }) {
  return http.get('/device/firmwareList', { params })
}

export async function fetchDeviceFirmwareInfo(params: { sn: string }) {
  return http.get('/device/firmwareInfo', { params })
}

export async function upgradeDeviceFirmware(form: { sn: string; firm_id: number }) {
  return http.post('/device/upgradeFirmware', form)
}

export async function deleteDevice(form: { device_id: number | string }) {
  return http.post('/device/delete', form)
}

/**
 * 入场记录
 * /park/list
 * @param page
 * @param pageSize
 * @returns
 */
export async function fetchAdmissionList(page?: number, page_size?: number, search?: string, shop_id?: string, start_time?: string,
  end_time?: string, direction?: string, remain_time?: number) {
  const params: any = {
    page,
    page_size,
  }

  if (shop_id) params.shop_id = shop_id
  if (start_time) params.start_time = start_time
  if (end_time) params.end_time = end_time
  if (search) params.search = search
  if (direction) params.direction = direction
  if (remain_time) params.remain_time = remain_time
  // return http.get(`/analysis/count${query.length ? `?${query.join('&')}` : ''}`)

  return http.get(`/park/list`, { params })
  /* return http.get(
    // `/park/list?page=${page}&page_size=${pageSize}&search=${search}${shopId === 0 ? '' : `&shop_id=${shopId}`}`
    `/park/list?page=${form.page}&page_size=${form.page_size}&direction=${form.direction}${query.length ? `&${query.join('&')}` : ''
    }`
  ) */
}

// 停车发券列表
export async function fetchTicketList(page_size: number, page: number, user_id: string, shop_id?: string, coupon_value?: number,
  start_time?: string, end_time?: string, search?: string, encrypt_phone?: boolean) {
  const params: any = {
    page,
    page_size,
  }
  if (shop_id) params.shop_id = shop_id
  if (user_id) params.user_id = user_id
  if (coupon_value) params.coupon_value = coupon_value
  if (start_time) params.start_time = start_time
  if (end_time) params.end_time = end_time
  if (search) params.search = search
  if (encrypt_phone) params.encrypt_phone = true
  return http.get(`/park/ticketList`, { params })
}

/**
 * 拉黑
 * /park/list
 * @returns
 */
export async function updatePark(form: { park_id: number; park_status: number }) {
  return http.post('/park/update', form)
}

/**
 * 管理员详情
 * /admin/detail
 * @returns
 */
export async function fetchAdminDetail(form: {}) {
  return http.post('/admin/detail', form)
}

// 管理员退出
export async function adminLoginOut() {
  return http.post(`/admin/loginOut`)
}

// 管理员退出
export async function updateAdminPassword(form: { old_password: string; new_password: string }) {
  return http.post(`/admin/updatePassword`, form)
}

/**
 * 交易记录
 * /analysis/transaction
 * @returns
 */
export async function fetchAnalysisTransaction(form: { shop_id?: string | number; month?: string }) {
  return http.get(`/analysis/transaction?shop_id=${form.shop_id}&month=${form.month}`)
}

/**
 * 免停功能：发送优惠券
 * /park/send
 * @returns
 */
export async function sendCoupon(form: { shop_id: string; phone: number; license_plate: string; coupon_value?: number }) {
  return http.post('/park/send', form)
}

/**
 * 核销(团购映射)：获取映射列表
 * /receipt/mapList
 * @returns
 */
export async function fetchReceiptMapList(params: {
  type: number
  shop_id: string | number
  page?: number
  page_size?: number
}) {
  return http.get('/receipt/mapList', { params })
}

/**
 * 核销(团购映射)：新增团购映射
 * /receipt/mapList
 * @returns
 */
export async function addReceiptMap(form: {
  type: number
  name: string
  shop_id: string | number
  min_price?: number
  max_price?: number
  wash_price?: number
}) {
  return http.post('/receipt/addMap', form)
}

/**
 * 核销(团购映射)：编辑团购映射
 * /receipt/mapList
 * @returns
 */
export async function updateReceiptMap(form: {
  map_id: string
  type: number
  name: string
  shop_id: string | number
  min_price?: number
  max_price?: number
  wash_price?: number
}) {
  return http.post('/receipt/updateMap', form)
}

/**
 * 核销(团购映射)：删除团购映射
 * /receipt/mapList
 * @returns
 */
export async function deleteReceiptMap(form: { map_id: string }) {
  return http.post('/receipt/deleteMap', form)
}

// 物料对账
export async function fetchMaterialDetail(form: { material_id?: number }) {
  return http.get(`/material/detail?material_id=${form.material_id}`)
}

export async function fetchMaterialList(form: { shop_id?: string | number; month?: string }) {
  return http.get(`/material/list?shop_id=${form.shop_id}&month=${form.month}`)
}

export async function updateMaterial(form: any) {
  return http.post(`/material/update`, form)
}

export async function createMaterial(form: any) {
  return http.post(`/material/add`, form)
}

export async function deleteMaterial(form: { material_id?: number }) {
  return http.get(`/material/delete?material_id=${form.material_id}`)
}

export async function fetchPendingReimburse() {
  return http.get(`/material/reimburse/pending`)
}

export async function fetchDoneReimburse() {
  return http.get(`/material/reimburse/done`)
}

export async function submitMaterialReimburse(form: { material_ids: number[] }) {
  return http.post(`/material/reimburse/submit`, form)
}

export async function withdrawMaterialReimburse(form: { material_id: number }) {
  return http.post(`/material/reimburse/withdraw`, form)
}

export async function settleMaterialReimburse(form: { material_ids: number[]; transfer_image_url: string }) {
  return http.post(`/material/reimburse/settle`, form)
}

// 运营对账
export async function fetchOperationDetail(form: { operation_id?: number }) {
  return http.get(`/operation/detail?operaion_id=${form.operation_id}`)
}

export async function fetchOperationList(form: { shop_id?: string | number; month?: string }) {
  return http.get(`/operation/list?shop_id=${form.shop_id}&month=${form.month}`)
}

export async function updateOperation(form: any) {
  return http.post(`/operation/update`, form)
}

export async function createOperation(form: any) {
  return http.post(`/operation/add`, form)
}

export async function deleteOperation(form: { operation_id?: number }) {
  return http.get(`/operation/delete?operation_id=${form.operation_id}`)
}

export async function previewOperationBill(form: {
  platform: number
  month?: string
  rows?: Record<string, string>[]
  image_urls?: string[]
}) {
  return http.post('/operation/previewBill', form, { timeout: 120000 })
}

export async function importOperationBill(form: {
  platform: number
  month: string
  items: any[]
  image_urls?: string[]
}) {
  return http.post('/operation/importBill', form)
}

// 托管分成
export async function fetchShopHostingFeeDetail(form: { hosting_fee_id?: number }) {
  return http.get(`/hosting/detail?hosting_fee_id=${form.hosting_fee_id}`)
}

export async function fetchShopHostingFeeList(form: { shop_id?: string | number }) {
  return http.get(`/hosting/list?shop_id=${form.shop_id}`)
}

export async function updateShopHostingFee(form: any) {
  return http.post(`/hosting/update`, form)
}

export async function createShopHostingFee(form: any) {
  return http.post(`/hosting/add`, form)
}

export async function deleteShopHostingFee(form: { hosting_fee_id?: number }) {
  return http.get(`/hosting/delete?hosting_fee_id=${form.hosting_fee_id}`)
}

// 门店盈利

export async function fetchShopProfitList(form: {
  shop_id?: string | number
  year?: string | number
  platform_from?: string
  platform_to?: string
  from?: string
  to?: string
}) {
  const q = new URLSearchParams()
  if (form.shop_id != null) q.set('shop_id', String(form.shop_id))
  if (form.year != null) q.set('year', String(form.year))
  if (form.platform_from) q.set('platform_from', form.platform_from)
  if (form.platform_to) q.set('platform_to', form.platform_to)
  if (form.from) q.set('from', form.from)
  if (form.to) q.set('to', form.to)
  return http.get(`/shop/profit?${q.toString()}`)
}

export async function updateShopProfit(form: any) {
  return http.post(`/shop/profit`, form)
}

// 核销店铺映射
export async function fetchShopHMapDetail(form: { map_id?: number }) {
  return http.get(`/receipt/shopMapDetail?map_id=${form.map_id}`)
}

export async function fetchShopMapList() {
  return http.get(`/receipt/shopMapList`)
}

export async function updateShopMap(form: any) {
  return http.post(`/receipt/updateShopMap`, form)
}

export async function createShopMap(form: any) {
  return http.post(`/receipt/addShopMap`, form)
}

export async function deleteShopMap(form: { map_id?: number }) {
  return http.post(`/receipt/deleteShopMap`, form)
}

export async function fetchReceiptList(page_size: number, page: number, search?: string, shop_id?: string, start_time?: string, end_time?: string) {
  const params: any = {
    page,
    page_size,
  }
  if (search) params.search = search
  if (shop_id) params.shop_id = shop_id
  if (start_time) params.start_time = start_time
  if (end_time) params.end_time = end_time
  return http.get(`/receipt/list`, { params })
}

// 广告设置
export async function fetchBannerList() {
  return http.get(`/banner/list`)
}

export async function updateBanner(form: any) {
  return http.post(`/banner/update`, form)
}

export async function createBanner(form: any) {
  return http.post(`/banner/add`, form)
}

export async function deleteBanner(form: { banner_id?: number }) {
  return http.get(`/banner/delete?banner_id=${form.banner_id}`)
}

// 活动
export async function fetchActivityList() {
  return http.get(`/activity/list`)
}

export async function fetchActivityDetail(activity_id: number) {
  return http.get(`/activity/detail?activity_id=${activity_id}`)
}

export async function createActivity(form: any) {
  return http.post(`/activity/add`, form)
}

export async function updateActivity(form: any) {
  return http.post(`/activity/update`, form)
}

export async function deleteActivity(form: { activity_id?: number }) {
  return http.post(`/activity/delete`, form)
}

// 洗车常见问题（后端 prefix: question）
export async function fetchWashQuestionList(params?: {
  page?: number
  page_size?: number
  status?: string | number
}) {
  const query: Record<string, string | number> = {
    page: params?.page ?? 1,
    page_size: params?.page_size ?? 200
  }
  if (params?.status !== undefined && params?.status !== '') {
    query.status = params.status
  }
  return http.get(`/question/list`, { params: query })
}

export async function fetchWashQuestionDetail(question_id: number) {
  return http.get(`/question/detail?question_id=${question_id}`)
}

export async function createWashQuestion(form: any) {
  return http.post(`/question/add`, form)
}

export async function updateWashQuestion(form: any) {
  return http.post(`/question/update`, form)
}

export async function deleteWashQuestion(form: { question_id?: number }) {
  return http.post(`/question/delete`, form)
}

// 管理员账号权限
export async function fetchAdminUserList(form: { shop_id?: string | number }) {
  return http.get(`/adminUser/list?shop_id=${form.shop_id}`)
}

export async function updateAdminUser(form: any) {
  return http.post(`/adminUser/update`, form)
}

export async function createAdminUser(form: any) {
  return http.post(`/adminUser/add`, form)
}

export async function deleteAdminUser(form: { admin_user_id?: number }) {
  return http.get(`/adminUser/delete?admin_user_id=${form.admin_user_id}`)
}

// 选址管理
export async function fetchMapShopList(form: { city?: string, status?: string }) {
  return http.get(`/mapShop/list?city=${form.city}&status=${form.status}`)
}

export async function updateMapShop(form: any) {
  return http.post(`/mapShop/update`, form)
}

export async function createMapShop(form: any) {
  return http.post(`/mapShop/add`, form)
}

export async function deleteMapShop(form: { map_shop_id?: number }) {
  return http.get(`/mapShop/delete?map_shop_id=${form.map_shop_id}`)
}

// 选址管理-地点周边房屋信息
export async function fetchSearchList(form: { page_size: number, page: number, }) {
  return http.get(`/house/searchList?page=${form.page}&page_size=${form.page_size}`)
}

// 选址管理-地点周边房屋信息查询结果
export async function fetchSearchResult(search_id: number) {
  return http.get(`/house/searchResult?search_id=${search_id}`)
}

// 选址管理-地点周边房屋小区户数列表
export async function fetchHouseList(form: { house_id: number, page_size: number, page: number, }) {
  return http.get(`/house/searchHouseList?house_id=${form.house_id}&page=${form.page}&page_size=${form.page_size}`)
}

// 选址管理-获取省份信息
export async function fetchProvince() {
  return http.get(`/house/getProvince`)
}

// 选址管理-地点周边房屋小区户数列表
export async function fetchCity(form: { province_id: string | number }) {
  return http.get(`/house/getCity?province_id=${form.province_id}`)
}

// 选址管理-地点周边房屋小区户数列表
export async function fetchDistrict(form: { city_id: string | number }) {
  return http.get(`/house/getDistrict?city_id=${form.city_id}`)
}

// 选址管理-创建查询地点周边房屋信息任务
export async function createHouseTask(form: { city_id: string | number, district_id: string | number, shop_name: string, range: number }) {
  return http.post(`/house/addTask`, form)
}

// 选址管理-重新编辑任务
export async function updateHouseTask(form: { shop_house_id: number, city_id: string | number, district_id: string | number, shop_name: string, range: number }) {
  return http.post(`/house/updateTask`, form)
}

// 选址管理-重新查询
export async function reQueryHouseTask(form: { shop_house_id: number }) {
  return http.post(`/house/reQuery`, form)
}

// 选址管理-删除任务
export async function deleteHouseTask(form: { shop_house_id: number }) {
  return http.post(`/house/deleteTask`, form)
}

// 选址打分测评
export async function fetchMapShopEvalList(form: {
  page?: number
  page_size?: number
  map_shop_id?: number
  search?: string
}) {
  const page = form.page ?? 1
  const pageSize = form.page_size ?? 20
  const mapShopId = form.map_shop_id ?? 0
  const search = encodeURIComponent(form.search || '')
  return http.get(`/mapShopEval/list?page=${page}&page_size=${pageSize}&map_shop_id=${mapShopId}&search=${search}`)
}

export async function fetchMapShopEvalDetail(id: number) {
  return http.get(`/mapShopEval/detail?id=${id}`)
}

export async function fetchMapShopEvalLatest(map_shop_id: number) {
  return http.get(`/mapShopEval/latest?map_shop_id=${map_shop_id}`)
}

export async function fetchMapShopEvalHouseHint(form: {
  map_shop_id?: number
  store_name?: string
  shop_house_id?: number
}) {
  const mapShopId = form.map_shop_id ?? 0
  const storeName = encodeURIComponent(form.store_name || '')
  const shopHouseId = form.shop_house_id ?? 0
  return http.get(`/mapShopEval/houseHint?map_shop_id=${mapShopId}&store_name=${storeName}&shop_house_id=${shopHouseId}`)
}

export async function saveMapShopEval(form: Record<string, any>) {
  return http.post('/mapShopEval/save', form)
}

export async function deleteMapShopEval(id: number) {
  return http.get(`/mapShopEval/delete?id=${id}`)
}

/** 链家地图联想（走后端，携带 LIANJIA_MAP_USER_TOKEN） */
export async function fetchHouseMapSug(params: {
  cityId: number | string
  query: string
  pageSize?: number
  signal?: AbortSignal
}) {
  const sp = new URLSearchParams({
    cityId: String(params.cityId),
    query: params.query,
    pageSize: String(params.pageSize ?? 30),
    hlsPreTag: '<i>',
    hlsPostTag: '</i>'
  })
  return http.get(`/house/mapSug?${sp.toString()}`, { signal: params.signal })
}

/** 更新链家 user-token：账号密码登录或直接粘贴 token */
export async function updateLianjiaToken(form: {
  username?: string
  password?: string
  user_token?: string
}) {
  return http.post(`/house/updateLianjiaToken`, form)
}

// 设备消息
export async function fetchDeviceMessage() {
  return http.get(`/device/message`)
}

// 获取设备在线离线记录
export async function fetchDeviceStatusList(
  sn: string,
  other: {
    page_size: number
    page: number
    order_no: string
    start_time: string // 2024-01-01 00:00:00
    end_time: string
  }
) {
  let query = `sn=${sn}&start_time=${other.start_time}&end_time=${other.end_time}&page=${other.page}&page_size=${other.page_size}`
  return http.get(`/device/statusList?${query}`)
}

// 获取设备详情
export async function fetchDeviceDetail(sn: string) {
  return http.get(`/device/detail?sn=${sn}`)
}

// 文明洗车处罚列表
export async function fetchCivilizedPenaltyList(page_size: number, page: number, search?: string) {
  const params: any = { page, page_size }
  if (search) params.search = search
  return http.get('/civilizedPenalty/list', { params })
}

// 文明洗车处罚详情
export async function fetchCivilizedPenaltyDetail(penalty_id: number) {
  return http.get(`/civilizedPenalty/detail?penalty_id=${penalty_id}`)
}

// 文明洗车处罚详情（按订单）
export async function fetchCivilizedPenaltyByOrder(order_id: number) {
  return http.get(`/civilizedPenalty/orderDetail?order_id=${order_id}`)
}

// 新增文明洗车处罚
export async function createCivilizedPenalty(data: {
  order_id: number
  is_violation?: number
  image_url?: string
  penalty_type?: number
  remark?: string
}) {
  return http.post('/civilizedPenalty/add', data)
}

// 修改文明洗车处罚
export async function updateCivilizedPenalty(data: {
  penalty_id: number
  is_violation?: number
  image_url?: string
  penalty_type?: number
  remark?: string
}) {
  return http.post('/civilizedPenalty/update', data)
}

// 洗车机客户
export async function fetchMachineCustomerList(params: {
  page?: number
  page_size?: number
  search?: string
}) {
  return http.get('/machineCustomer/list', { params })
}

export async function updateMachineCustomer(form: {
  id: number
  name?: string
  contact?: string
  deal_count?: number
}) {
  return http.post('/machineCustomer/update', form)
}

export async function fetchMachineCustomerFollowList(customer_id: number) {
  return http.get('/machineCustomer/followList', { params: { customer_id } })
}

export async function addMachineCustomerFollow(form: {
  customer_id: number
  content: string
}) {
  return http.post('/machineCustomer/addFollow', form)
}

export async function deleteMachineCustomer(id: number) {
  return http.get(`/machineCustomer/delete?id=${id}`)
}

export async function sendMachineCustomerBulkSms(phones: string[]) {
  return http.post('/machineCustomer/sendBulkSms', { phones })
}

export async function fetchJoinApplyList(params: {
  page?: number
  page_size?: number
  search?: string
}) {
  return http.get('/joinApply/list', { params })
}

export async function updateJoinApply(form: {
  id: number
  name?: string
  phone?: string
  deal_count?: number
}) {
  return http.post('/joinApply/update', form)
}

export async function fetchJoinApplyFollowList(apply_id: number) {
  return http.get('/joinApply/followList', { params: { apply_id } })
}

export async function addJoinApplyFollow(form: {
  apply_id: number
  content: string
}) {
  return http.post('/joinApply/addFollow', form)
}

export async function deleteJoinApply(id: number) {
  return http.get(`/joinApply/delete?id=${id}`)
}